var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132.341,
    height: 131.84,
    viewBox: "0 0 132.341 131.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chemistry",
    transform: "translate(0 -0.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(3.385 0.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M142.03,66.886a65.614,65.614,0,0,1-9.282,33.748c-11.506,19.268-32.841,28-56.914,28-36.407,0-62.759-25.891-62.759-62.3,0-20.479,6.453-38.224,21.1-50.315A65.922,65.922,0,0,1,142.03,66.886Z",
    transform: "translate(-13.075 -0.966)",
    fill: "#fee135"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M121.621,137.384a2.18,2.18,0,0,1-3.076-1.991V70.858l.039-.012a2.92,2.92,0,0,0,1.337-4.576q-1.215-1.564-2.521-3.052a2.973,2.973,0,0,0-2.233-1.015h-12.3a4.505,4.505,0,0,0-4.535,4.125,4.43,4.43,0,0,0,3.095,4.53v71.773c0,.038-1.233.135-2.874.242a7.5,7.5,0,0,1-7.984-7.488c.007-10.733.011-28.66.011-28.66V70.858a4.43,4.43,0,0,0,3.095-4.53A4.505,4.505,0,0,0,89.138,62.2H74.9a4.505,4.505,0,0,0-4.535,4.125,4.43,4.43,0,0,0,3.095,4.53v41.513a13.43,13.43,0,0,1-22.115,10.244l-.3-.256A13.427,13.427,0,0,1,46.3,112.121V70.84a4.429,4.429,0,0,0-1.324-8.656s-6.76,0-11.179.01a2.866,2.866,0,0,1-2.75-3.685l.038-.128a2.867,2.867,0,0,0-4.557-3.043,65.921,65.921,0,1,0,97.959,85.1,2.181,2.181,0,0,0-2.773-3.1l-.094.043Z",
    transform: "translate(-1.433 -39.81)",
    fill: "#f7c011"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599",
    transform: "translate(0 24.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(27.722 47.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M129.173,293.1l-18.536-18.536-3.584,3.584V293.1Z",
    transform: "translate(-107.053 -274.565)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(27.985 3.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M108.07,105.578h11.881v62H108.07Z",
    transform: "translate(-108.07 -105.578)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M24.657,167.578h4.466v-62H22.745V157.9L2.22,178.423a7.529,7.529,0,0,0,5.324,12.853H19.136a7.529,7.529,0,0,1-5.324-12.853Z",
    transform: "translate(0 -101.773)",
    fill: "#faf58c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M107.853,90.886H97.959a4.429,4.429,0,0,0,0,8.857h9.894a4.429,4.429,0,1,0,0-8.857Z",
    transform: "translate(-69.31 -90.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M80.812,95.314a4.429,4.429,0,0,1,4.429-4.429H80.273a4.429,4.429,0,0,0,0,8.857h4.968A4.429,4.429,0,0,1,80.812,95.314Z",
    transform: "translate(-56.204 -90.885)",
    fill: "#faf58c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(18.443 64.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M113.663,362.454a7.5,7.5,0,0,0-.5-10.111l-12.07-12.07H71.219v22.181Z",
    transform: "translate(-71.219 -340.273)",
    fill: "#00c3ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M27.438,360.744a7.529,7.529,0,0,1-5.324-12.853l7.618-7.618H14.29L2.22,352.343A7.529,7.529,0,0,0,7.544,365.2H55.066a7.409,7.409,0,0,0,6.867-4.452Z",
    transform: "translate(0 -275.693)",
    fill: "#34b0d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(27.089 28.586)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_138",
    "data-name": "Ellipse 138",
    cx: 5.833,
    cy: 5.833,
    r: 5.833,
    transform: "translate(4.217 32.338)",
    fill: "#00c3ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 3.317,
    cy: 3.317,
    r: 3.317,
    transform: "translate(0 18.978)",
    fill: "#00c3ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 2.345,
    cy: 2.345,
    r: 2.345,
    transform: "translate(4.217)",
    fill: "#00c3ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(63.916 24.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(9.106 3.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M281.989,105.646c0,.012,0,.023,0,.035v84.76a8.566,8.566,0,0,0,11.118-8.172V105.646Z",
    transform: "translate(-281.989 -105.646)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    transform: "translate(3.105 3.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M265.608,105.646h-6.792V182.27a8.561,8.561,0,0,0,6.792,8.374Z",
    transform: "translate(-258.816 -105.646)",
    fill: "#6ee1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(10.333 44.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M286.73,262.885v44.363a8.563,8.563,0,0,0,9.893-8.457V262.885Z",
    transform: "translate(-286.73 -262.885)",
    fill: "#ff8500"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M267.378,298.213V262.885h-8.56v35.906a8.561,8.561,0,0,0,13.34,7.1A8.559,8.559,0,0,1,267.378,298.213Z",
    transform: "translate(-255.712 -218.363)",
    fill: "#fa690f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M279.767,90.953H270.2a4.429,4.429,0,0,0,0,8.857h9.568a4.429,4.429,0,1,0,0-8.857Z",
    transform: "translate(-260.864 -90.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M252.346,95.382a4.429,4.429,0,0,1,4.429-4.429h-5.52a4.429,4.429,0,1,0,0,8.857h5.52A4.429,4.429,0,0,1,252.346,95.382Z",
    transform: "translate(-246.826 -90.953)",
    fill: "#6ee1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607",
    transform: "translate(27.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(8.649 3.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M388.228,105.646c.012.128.021.256.021.385V190.29a8.563,8.563,0,0,0,11.556-8.02V105.646Z",
    transform: "translate(-388.228 -105.646)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605",
    transform: "translate(3.105 3.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M373.348,105.646h-6.529V182.27a8.562,8.562,0,0,0,6.529,8.316Z",
    transform: "translate(-366.819 -105.646)",
    fill: "#6ee1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(10.946 30.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M397.1,210.147v58.091c.237.02.477.032.72.032a8.56,8.56,0,0,0,8.56-8.561V210.147Z",
    transform: "translate(-397.098 -210.147)",
    fill: "#20b7a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M375.38,258.914V210.147h-8.561V259.71a8.558,8.558,0,0,0,13.524,6.972,8.56,8.56,0,0,1-4.964-7.768Z",
    transform: "translate(-363.714 -179.281)",
    fill: "#269ab1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M387.519,90.953h-9.656a4.429,4.429,0,1,0,0,8.857h9.656a4.429,4.429,0,1,0,0-8.857Z",
    transform: "translate(-368.616 -90.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M359.8,95.382a4.429,4.429,0,0,1,4.429-4.429h-4.968a4.429,4.429,0,0,0,0,8.857h4.968A4.428,4.428,0,0,1,359.8,95.382Z",
    transform: "translate(-354.828 -90.953)",
    fill: "#6ee1ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.f2581e7cce308a3b5224e3f68b03815a.svg";
export { ForwardRef as ReactComponent };